import { OnThisPageItem } from '../types/onThisPage';

export interface ContactPerson {
  name: string;
  role?: string;
  detail?: string;
  organization?: string;
  email?: string;
  phone?: string;
  website?: { href: string; label: string };
}

export interface ContactOffice {
  name: string;
  lines: string[];
  email: string;
}

export interface ContactRegion {
  id: string;
  title: string;
  people: ContactPerson[];
}

export const CONTACT_REGIONS: ContactRegion[] = [
  {
    id: 'central',
    title: 'Central',
    people: [
      {
        name: 'Dr. Yulia Lin',
        role: 'Project Sponsor',
        email: 'yulia.lin@sunnybrook.ca',
      },
      {
        name: 'Troy Thompson',
        role: 'Program Manager',
        email: 'troy.thompson@sunnybrook.ca',
        phone: '289-339-6648',
      },
      {
        name: 'Dr. T. (Dorien) Ruijs',
        role: 'Clinical Project Coordinator',
        detail: 'Transfusion Medicine Physician',
        email: 'dorien.ruijs@sunnybrook.ca',
      },
      {
        name: 'Stephanie Cope',
        role: 'Regional Project Coordinator',
        email: 'stephanie.cope@sunnybrook.ca',
        phone: '289-314-3734',
      },
      {
        name: 'Alison Wendt',
        role: 'Regional Project Coordinator',
        email: 'alison.wendt@sunnybrook.ca',
        phone: '647-998-6746',
      },
    ],
  },
  {
    id: 'northeast',
    title: 'Northeast',
    people: [
      {
        name: 'Dr. Antonio Giulivi',
        role: 'Program Sponsor',
        email: 'agiulivi@eorla.ca',
      },
      {
        name: 'Dr. Alan Tinmouth',
        role: 'Program Co-Sponsor',
        email: 'atinmouth@toh.ca',
      },
      {
        name: 'Tracy Cameron',
        role: 'Regional Manager',
        email: 'tcameron@ohri.ca',
        phone: '613-668-1021',
      },
      {
        name: 'Alexis Iob',
        role: 'Regional Project Coordinator',
        email: 'aliob@ohri.ca',
        phone: '343-630-6619',
      },
      {
        name: 'Kimberly Schonewille',
        role: 'Regional Project Coordinator',
        email: 'kschonewille@ohri.ca',
        phone: '343-549-2220',
      },
      {
        name: 'Andrew Duyvestyn',
        role: 'Information Technology Analyst',
        email: 'aduyvestyn@ohri.ca',
        phone: '514-992-7753',
      },
    ],
  },
  {
    id: 'southwest',
    title: 'Southwest',
    people: [
      {
        name: 'Dr. Andrew Shih',
        role: 'Project Sponsor',
        email: 'shiha@mcmaster.ca',
      },
      {
        name: 'Rebecca Barty',
        role: 'Regional Manager',
        email: 'bartyr@mcmaster.ca',
      },
      {
        name: 'Donna Berta',
        role: 'Clinical Project Coordinator',
        detail: 'Nursing',
        email: 'bertad@mcmaster.ca',
        phone: '289-237-4010',
      },
      {
        name: 'Laura Aseltine',
        role: 'Regional Project Coordinator',
        email: 'aseltinl@mcmaster.ca',
      },
      {
        name: 'Sheena Scheuermann',
        role: 'Regional Project Coordinator',
        email: 'sanders@mcmaster.ca',
        phone: '905-928-0538',
      },
    ],
  },
];

export const CONTACT_MINISTRY: ContactOffice = {
  name: 'Ministry of Health',
  lines: ['5700 Yonge Street, 3rd Floor', 'Toronto, ON M2M 4K5'],
  email: 'ONBlood@ontario.ca',
};

export const CONTACT_TTISS: ContactPerson = {
  name: 'Melanie St John',
  role: 'Ontario TTISS Coordinator',
  organization: 'McMaster University',
  email: 'Stjohnm1@mcmaster.ca',
  phone: '905 525-9140 ext. 21645',
  website: { href: 'https://ttiss.mcmaster.ca', label: 'ttiss.mcmaster.ca' },
};

export const CONTACT_FACTOR: ContactPerson[] = [
  {
    name: 'Sarah Crymble',
    role: 'Hemophilia Provincial Coordinator',
    organization: "St. Michael's Hospital",
    email: 'Sarah.Crymble@unityhealth.to',
    phone: '416-864-6060 ext. 46981',
  },
  {
    name: 'Antonette Travas',
    role: 'Hemophilia Provincial Coordinator',
    organization: "St. Michael's Hospital",
    email: 'antonette.travas@unityhealth.to',
    phone: '416-864-6060 ext. 2579',
  },
];

export const CONTACT_ONTRAC: ContactPerson[] = [
  {
    name: 'Dr. John Freedman',
    role: 'Program Director',
    organization: "St. Michael's Hospital",
  },
  {
    name: 'Alanna Howell R.N.',
    role: 'Program Manager',
    organization: "St. Michael's Hospital",
    email: 'Alanna.Howell@unityhealth.to',
  },
  {
    name: 'Provincial Blood Conservation Program',
    website: { href: 'https://www.ontracprogram.com', label: 'www.ontracprogram.com' },
  },
];

export const CONTACT_WEBSITE_EMAIL = 'transfusionontario@gmail.com';

export const CONTACT_SECTIONS: OnThisPageItem[] = [
  {
    id: 'orbcon',
    label: 'ORBCoN contacts',
    children: [
      { id: 'central', label: 'Central' },
      { id: 'northeast', label: 'Northeast' },
      { id: 'southwest', label: 'Southwest' },
    ],
  },
  { id: 'ministry', label: 'Ministry of Health' },
  { id: 'ttiss', label: 'TTISS' },
  { id: 'factor', label: 'Factor redistribution' },
  { id: 'ontrac', label: 'ONTraC' },
  { id: 'website', label: 'This website' },
];

export function contactSectionIds(items: OnThisPageItem[] = CONTACT_SECTIONS): string[] {
  return items.flatMap((item) => [item.id, ...contactSectionIds(item.children ?? [])]);
}
